<section *ngIf="!spinner">
  <div class="padre">
    <div class="row">
      <div class="coli col-sm-6 col-6 cont">
        <div class="info i1">
          <h6>MATRICULACIONES</h6>
          <div
            class="contenido"
            type="button"
            (click)="navigate('MATRICULACION')"
          >
            <img src="assets/img/directions_car_white_48dp.svg" width="30" />
            <label class="number"> {{ datosCuadros?.matriculaciones }}</label>
          </div>
        </div>
      </div>

      <div class="coli col-sm-6 col-6 cont">
        <div class="info i2">
          <h6>CAMBIO PROP</h6>
          <div
            class="contenido"
            type="button"
            (click)="navigate('CAMBIO DE PROPIEDAD')"
          >
            <img src="assets/img/people_white_48dp.svg" width="30" />
            <label class="number"> {{ datosCuadros?.cambioPropiedad }}</label>
          </div>
        </div>
      </div>

      <div class="coli col-sm-6 col-6 cont">
        <div class="info i3">
          <h6>DIST. MEDIO</h6>
          <div
            class="contenido"
            type="button"
            (click)="navigate('DISTINTIVO MEDIOAMBIENTAL')"
          >
            <img src="assets/img/park_white_48dp.svg" width="30" />
            <label class="number"> {{ datosCuadros?.distintivo }}</label>
          </div>
        </div>
      </div>
      <div class="coli col-sm-6 col-6 cont">
        <div class="info i4">
          <h6>JUST. PROFESIONAL</h6>
          <div
            class="contenido"
            type="button"
            (click)="navigate('JUSTIFICANTE')"
          >
            <img src="assets/img/feed_white_48dp.svg" width="30" />
            <label class="number"> {{ datosCuadros?.justificante }}</label>
          </div>
        </div>
      </div>

      <div class="coli col-sm-6 col-6 cont">
        <div class="info i5">
          <h6>BAJAS</h6>
          <div class="contenido" type="button" (click)="navigate('BAJAS')">
            <img src="assets/img/trending_down_white_48dp.svg" width="30" />
            <label class="number"> {{ datosCuadros?.bajas }}</label>
          </div>
        </div>
      </div>

      <div class="coli col-sm-6 col-6 cont">
        <div class="info i6">
          <h6>INFORME</h6>
          <div class="contenido" type="button" (click)="navigate('INFORME')">
            <img src="assets/img/assessment_white_48dp.svg" width="30" />
            <label class="number"> {{ datosCuadros?.informe }}</label>
          </div>
        </div>
      </div>

      <div class="coli col-sm-6 col-6 cont">
        <div class="info i7">
          <h6>INCIDENCIAS</h6>
          <div class="contenido" type="button" (click)="navigateIncidencias()">
            <img src="assets/img/report_problem_white_48dp.svg" width="30" />
            <label class="number" ng> {{ estadistica?.incidencias }}</label>
          </div>
        </div>
      </div>
    </div>
    <mat-card>
      <mat-card-content>
        <!-- Ultimas tramitaciones --------------------->
        <div class="row">
          <div class="col-12" style="text-align: center">
            <h5>Estadisticas del año en curso</h5>
          </div>
        </div>
        <div class="row">
          <div class="col-12" style="text-align: start">
            <h5>
              <button
                mat-icon-button
                class="float-right mr-5"
                data-toggle="collapse"
                data-target="#collapseSearch"
                aria-expanded="false"
                aria-controls="collapseSearch"
              >
                <mat-icon>settings </mat-icon>
              </button>
            </h5>
          </div>
        </div>
        <div class="collapse" id="collapseSearch">
          <div class="row" [formGroup]="dateForm">
            <div class="col-lg-2"></div>
            <div class="col-lg-4" *ngIf="rol != 'GRUPO'"></div>
            <div class="col-lg-3 col-md-4 col-sm-12" *ngIf="rol === 'GRUPO'">
              <label class="form-label">Colaborador</label>
              <select
                class="custom-select form-control"
                formControlName="colaborador"
                (ngModelChange)="applyFilter($event)"
              >
                <option [value]="'TODOS'">Todos</option>
                <option
                  *ngFor="let colaborador of colaboradores; let i = index"
                  [value]="colaborador"
                >
                  {{ colaborador }}
                </option>
              </select>
            </div>
            <mat-form-field
              appearance="standard"
              class="col-lg-3 col-md-4 col-sm-10"
            >
              <mat-label>Fecha inicio - Fecha fin</mat-label>
              <mat-date-range-input
                [rangePicker]="picker3"
                matTooltip="Elija un rango de fechas y pulse aceptar. Presione restablecer para volver a mostrar el rango completo de fechas."
              >
                <input
                  matStartDate
                  formControlName="fromDate"
                  placeholder="Fecha inicio"
                  [value]="fromDate"
                />
                <input
                  matEndDate
                  formControlName="toDate"
                  placeholder="Fecha fin"
                  [value]="toDate"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle
                matSuffix
                [for]="picker3"
              ></mat-datepicker-toggle>
              <mat-date-range-picker #picker3></mat-date-range-picker>
            </mat-form-field>

            <div class="col-lg-3 col-md-4 col-sm-10 botones">
              <button
                mat-button
                class="aceptar"
                (click)="filterByDateRange(matStartDate, matEndDate)"
                [disabled]="
                  !dateForm.get('fromDate').value ||
                  !dateForm.get('toDate').value ||
                  !dateForm.get('colaborador').value
                "
              >
                Aceptar
              </button>
              <button mat-button class="restablecer" (click)="restablecer()">
                Restablecer
              </button>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 5px">
          <div class="col-lg-5 col-md-5 col-sm-12 col-12 cuadro">
            <div class="col-12" style="text-align: center">
              <h5>Nueva Solicitud</h5>
            </div>
            <div class="row mt-5 mb-4">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b1"
                  (click)="toGoMatriculacion()"
                  [disabled]="rol === 'VENTAS' || rol === 'CONSULTA'"
                >
                  Matriculacion
                </button>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b2"
                  (click)="toGoCambio()"
                  [disabled]="rol === 'VENTAS' || rol === 'CONSULTA'"
                >
                  Cambio prop.
                </button>
              </div>

              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b3"
                  (click)="toGoDistintivo()"
                  [disabled]="rol === 'VENTAS' || rol === 'CONSULTA'"
                >
                  Dist. Medio.
                </button>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b4"
                  (click)="toGoJustificante()"
                  [disabled]="rol === 'CONSULTA'"
                >
                  J.profesional
                </button>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b5"
                  (click)="toGoReduccion()"
                  [disabled]="rol === 'VENTAS' || rol === 'CONSULTA'"
                >
                  Doble Transf.
                </button>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b6"
                  (click)="toGoInforme()"
                  [disabled]="rol === 'CONSULTA'"
                >
                  Informe
                </button>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b6"
                  (click)="toGoBajas()"
                  [disabled]="rol === 'VENTAS' || rol === 'CONSULTA'"
                >
                  Bajas
                </button>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6">
                <button
                  mat-button
                  class="aceptar b7"
                  (click)="toGoFirmaDocumentos()"
                  [disabled]="rol === 'CONSULTA'"
                >
                  Firma Docs
                </button>
              </div>
            </div>

          </div>
          <div class="col-lg-7 col-md-7 col-sm-12 col-12 cuadro">
            <div class="col-12" style="text-align: center">
              <h5>Últimos trámites</h5>
            </div>

            <!--- Tabla basica de tramites --->
            <mat-table [dataSource]="datasource">
              <!-- Position Column -->
              <ng-container matColumnDef="expediente">
                <mat-header-cell *matHeaderCellDef> No. </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.numeroExpediente }}
                </mat-cell>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="tramite">
                <mat-header-cell *matHeaderCellDef> Trámite </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.tramite | null }}
                </mat-cell>
              </ng-container>

              <!-- Weight Column -->
              <ng-container matColumnDef="estado">
                <mat-header-cell *matHeaderCellDef> Estado </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.status | null }}
                </mat-cell>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="recepcion">
                <mat-header-cell *matHeaderCellDef>
                  F.Recepcion
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                  {{ element.fechaEntrada | date : "dd/MM/yy" }}
                </mat-cell>
              </ng-container>

              <mat-header-row
                *matHeaderRowDef="displayedColumns"
              ></mat-header-row>
              <mat-row
                *matRowDef="let row; columns: displayedColumns"
              ></mat-row>
            </mat-table>
          </div>
        </div>
        <!--- Graficas ----------->
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <app-linechart
              [expedientes]="listEstadisticas?.meses"
              *ngIf="listEstadisticas?.meses && !pintar"
            ></app-linechart>
            <app-linechart-range
              [expedientes]="dats"
              [labels]="labels"
              [desde]="desde"
              [hasta]="hasta"
              *ngIf="pintar"
            ></app-linechart-range>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-12">
            <app-piechart
              [datos]="estats"
              *ngIf="estats.length === 6"
            ></app-piechart>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</section>

<div
  *ngIf="spinner"
  class="spinner swal2-container swal2-center swal2-backdrop-show"
>
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png" />
</div>
